import React from 'react';

const TopArrow = ({ className = '', ...props }) => {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={`text-v3-purple-primary ${className}`} {...props}>
  <path d="M12 20V4M12 4L18 10M12 4L6 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  );
};

export default TopArrow;
